export interface Category {
  id: string;
  userId: string | null; // null = system category
  name: string;
  nameEn?: string; // English name for system categories
  icon: string;
  color: string;
  type?: 'income' | 'expense'; // Optional - not all categories have type
  deductibleBR?: boolean;
  deductibleUK?: boolean;
  taxDeductibleBr?: boolean; // Alternative field name from API
  taxDeductibleUk?: boolean; // Alternative field name from API
  isSystem: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface CategoriesListResponse {
  categories: Category[];
  total: number;
}

export interface CreateCategoryInput {
  name: string;
  icon: string;
  color: string;
  type: 'income' | 'expense';
  deductibleBR: boolean;
  deductibleUK: boolean;
}

export interface UpdateCategoryInput extends Partial<CreateCategoryInput> {}

export const CATEGORY_ICONS = [
  'ShoppingCart',
  'Utensils',
  'Car',
  'Home',
  'Heart',
  'Briefcase',
  'GraduationCap',
  'Plane',
  'Gift',
  'Smartphone',
  'Laptop',
  'Coffee',
  'Music',
  'Film',
  'Book',
  'Dumbbell',
  'Pill',
  'Scissors',
  'Wrench',
  'Zap',
  'Droplet',
  'Wifi',
  'CreditCard',
  'DollarSign',
  'TrendingUp',
  'Building',
  'Store',
  'Package',
  'Truck',
  'Bus',
  'Train',
  'Bike',
  'PiggyBank',
  'Banknote',
  'Receipt',
  'Tag',
] as const;

export const CATEGORY_COLORS = [
  '#EF4444', // red
  '#F97316', // orange
  '#F59E0B', // amber
  '#EAB308', // yellow
  '#84CC16', // lime
  '#22C55E', // green
  '#10B981', // emerald
  '#14B8A6', // teal
  '#06B6D4', // cyan
  '#0EA5E9', // sky
  '#3B82F6', // blue
  '#6366F1', // indigo
  '#8B5CF6', // violet
  '#A855F7', // purple
  '#D946EF', // fuchsia
  '#EC4899', // pink
  '#F43F5E', // rose
  '#6B7280', // gray
] as const;
